import React from "react";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

// Reusable public pricing card. Get Started opens the existing flow:
// real plans -> client registration with the plan pre-selected; Enterprise -> Request Service.
export function PublicPlanCard({ plan, popular, onGetStarted }) {
  const isEnterprise = plan.amount === null;
  return (
    <div
      data-testid={`public-plan-${plan.lookup_key}`}
      className={`relative flex flex-col rounded-2xl border p-6 bg-white ${popular ? "border-blue-500 ring-2 ring-blue-500/20 shadow-lg" : "border-slate-200 shadow-sm"}`}
    >
      {popular && (
        <span data-testid="most-popular-badge" className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-blue-600 text-white text-xs font-semibold shadow">
          Most Popular
        </span>
      )}
      <h3 className="font-head text-xl font-semibold text-slate-900">{plan.name}</h3>
      <p className="text-sm text-slate-500 mt-0.5">{plan.tagline}</p>
      <div className="mt-4 flex items-end gap-1">
        {isEnterprise ? (
          <span className="font-head text-3xl font-semibold text-slate-900">Custom</span>
        ) : (
          <>
            <span className="font-head text-4xl font-semibold text-slate-900">${plan.amount}</span>
            <span className="text-slate-500 mb-1">/mo</span>
          </>
        )}
      </div>
      <p className="mt-3 text-xs font-medium text-blue-700 bg-blue-50 border border-blue-100 rounded-lg px-3 py-1.5">{plan.best_for}</p>
      <ul className="mt-5 space-y-2 flex-1">
        {plan.features.map((f, i) => (
          <li key={i} className="flex items-start gap-2 text-sm text-slate-600">
            <Check className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" /> {f}
          </li>
        ))}
      </ul>
      <Button
        data-testid={`get-started-${plan.lookup_key}`}
        onClick={() => onGetStarted(plan)}
        className={`mt-6 h-11 w-full rounded-lg ${popular ? "bg-blue-600 hover:bg-blue-700 text-white" : "bg-slate-900 hover:bg-slate-800 text-white"}`}
      >
        {isEnterprise ? "Contact Sales" : "Get Started"}
      </Button>
    </div>
  );
}
